import { Switch as AriaSwitch, type SwitchProps as AriaSwitchProps } from "react-aria-components";
import React from "react";

import { cn } from "@/lib/helpers/cn";

export type Switch2Props = Omit<AriaSwitchProps, "children" | "className"> & {
  children?: React.ReactNode;
  className?: string;
};

export function Switch2({ children, className, ...props }: Switch2Props) {
  return (
    <AriaSwitch {...props} className={cn(root, className)}>
      <div className={track}>
        <span className={handle} />
      </div>
      {children}
    </AriaSwitch>
  );
}

const root = cn(
  "tw:group tw:relative tw:mb-0! tw:flex! tw:items-start tw:gap-2 tw:outline-none tw:hover:cursor-pointer tw:disabled:cursor-not-allowed",
);

const track = cn(
  // default
  "tw:relative tw:inline-flex tw:h-7.5 tw:w-13 tw:shrink-0 tw:items-center tw:rounded-full",
  "tw:border tw:border-stroke-quaternary tw:bg-fill-senary",
  // hover
  "tw:group-hover:border-stroke-tertiary tw:group-hover:bg-fill-quinary",
  // pressed
  "tw:group-pressed:border-stroke-quaternary tw:group-pressed:bg-fill-quinary",
  // focus
  "tw:group-focus-visible:ring-2 tw:group-focus-visible:ring-layer-focus tw:group-focus-visible:outline-0",
  // selected
  "tw:group-selected:border-transparent tw:group-selected:bg-fill-teal-primary",
  // hover selected
  "tw:group-hover:group-selected:border-transparent tw:group-hover:group-selected:bg-fill-teal-secondary",
  // pressed selected
  "tw:group-pressed:group-selected:bg-fill-teal-primary-w20",
  // disabled
  "tw:group-disabled:border-stroke-quaternary tw:group-disabled:bg-fill-senary tw:group-disabled:opacity-50",
  "tw:group-disabled:group-hover:border-stroke-quaternary tw:group-disabled:group-hover:bg-fill-senary",
  "tw:group-disabled:group-pressed:bg-fill-senary",
  // disabled selected
  "tw:group-disabled:group-selected:border-transparent tw:group-disabled:group-selected:bg-fill-quinary",
  "tw:group-disabled:group-hover:group-selected:border-transparent tw:group-disabled:group-hover:group-selected:bg-fill-quinary",
  "tw:group-disabled:group-pressed:group-selected:bg-fill-quinary",
);

const handle = cn(
  "tw:m-0.5 tw:size-6.5 tw:-translate-x-px tw:rounded-full tw:transition-transform tw:duration-200",
  // default
  "tw:bg-fill-white tw:shadow-lg",
  // disabled
  "tw:group-disabled:shadow-none",
  // selected
  "tw:group-selected:translate-x-[calc(100%-5px)]",
);
